
import { defineComponent } from "vue";
import WelcomePane from "./components/WelcomePane.vue";
import FormPane from "@/modules/login/components/FormPane.vue";
import LanguageChange from "./components/LanguageChange.vue";

export default defineComponent({
  name: "LoginPage",
  components: {
    WelcomePane,
    FormPane,
    LanguageChange,
  },
  data() {
    return {
      fontSize: "94px",
    };
  },
  mounted() {
    let ibex = `
                                                                           .~!: 
                                                                         .75PPY.
   .                                                                   :?5PP57. 
 :G#B~   JBBBBBBBBBBBG5?^     7GBBBBBBBBBBBBBP.  ?BB5^               :?555Y!.   
 !@@@J  .&@@&GGGGGGGB&@@@Y    B@@@BGGGGGGGGGG5.  J@@@@P~           ^7JYJ?^      
 !@@@J  .&@@G        .P@@@!   G@@&.               :J#@@@G!       ^7???!:        
 !@@@J  .&@@G         P@@&^   G@@&.                 .?B@@@^  .  :777~:          
 !@@@J  .&@@&PPPPPPPG#@@G^    G@@&5YYYYYYYY7           ~!^.Y##B? .:.            
 !@@@J  .&@@&BBBBBBBB#@@&P~   G@@@&&&&&&&&&G.             ^@@@@B                
 !@@@J  .&@@G         ^B@@&^  G@@&^........           7GB5::?J7.~GB5~           
 !@@@J  .&@@G          5@@@!  G@@&.                .?#@@@B:     7&@@@G!         
 !@@@J  .&@@B~~~~~~~~!Y@@@B.  B@@&!~~~~~~~~~~^   :J#@@@G!        .?#@@@B7.      
 ~@@@?  .B@@@@@@@@@@@@@&BJ.   P@@@@@@@@@@@@@@@?  P@@&P~            .7B@@@?      
  !J7.   :!7777777777!~:      .!7777777777777!.  :7?^                 ~?!.      
    `;
    console.clear();
    console.log(`%c ${ibex}`, "font-size: 11px");
    console.log("%c Ibex Medical Analytics", "font-size: 36px");
  },
});
